import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../configuration/setup/store';
import { configureIsMobile } from '../app/common/responsive';

const tableMode = {
    LIST: 'list',
    CARDS: 'cards',
    TABLE: 'table',
} as const;

export type TableMode = (typeof tableMode)[keyof typeof tableMode];

export interface SettingsState {
    groupsListMode: TableMode;
    usersListMode: TableMode;
}

const preselectedTableMode = () => (configureIsMobile(window)() ? tableMode.CARDS : tableMode.TABLE);
const initialState: SettingsState = {
    groupsListMode: preselectedTableMode(),
    usersListMode: preselectedTableMode(),
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        changeGroupsListMode: (state, action: PayloadAction<TableMode>) => {
            state.groupsListMode = action.payload;
        },
        changeUsersListMode: (state, action: PayloadAction<TableMode>) => {
            state.usersListMode = action.payload;
        },
    },
});

export const { changeUsersListMode, changeGroupsListMode } = settingsSlice.actions;

export default settingsSlice.reducer;

// SELECTORS
export const getUsersListMode = (state: RootState) => state.setting.usersListMode;
export const getGroupsListMode = (state: RootState) => state.setting.groupsListMode;
